module.exports = __webpack_public_path__ + "img/Unidad11-2.640aad05.png";